import { AxiosResponse } from 'axios';
import $api from '@/http/index';
import { IMutedDoc, INotificationPreferences } from '@/types/notificationPreferences.types';

/**
 * Пользовательские настройки уведомлений (матрица категория × канал + mute документов).
 * Эндпоинты: `api/v1/NotificationPreferences`.
 */
export class NotificationPreferencesService {
    static async fetch(): Promise<AxiosResponse<INotificationPreferences>> {
        return $api.get<INotificationPreferences>('/NotificationPreferences');
    }

    static async save(prefs: INotificationPreferences): Promise<AxiosResponse<void>> {
        return $api.put('/NotificationPreferences', prefs);
    }

    /** Сбросить настройки к настройкам организации (категории, каналы). */
    static async reset(): Promise<AxiosResponse<void>> {
        return $api.post('/NotificationPreferences/reset');
    }

    /** Список заглушённых документов (с заголовками). */
    static async fetchMuted(): Promise<AxiosResponse<IMutedDoc[]>> {
        return $api.get<IMutedDoc[]>('/NotificationPreferences/muted-docs');
    }

    /** Заглушён ли документ у текущего пользователя. */
    static async isMuted(docId: string): Promise<AxiosResponse<boolean>> {
        return $api.get<boolean>(`/NotificationPreferences/muted-docs/${docId}`);
    }

    /** Заглушить документ. */
    static async mute(docId: string): Promise<AxiosResponse<void>> {
        return $api.post(`/NotificationPreferences/muted-docs/${docId}`);
    }

    /** Снять заглушку документа. */
    static async unmute(docId: string): Promise<AxiosResponse<void>> {
        return $api.delete(`/NotificationPreferences/muted-docs/${docId}`);
    }
}
